export function getAddress({ street, apartment_no, building_no, city }) {
  street = street ? `ul. ${street}` : "";
  building_no = building_no || "";
  apartment_no = apartment_no ? "/" + apartment_no : "";
  city = city || "";

  return `${street} ${building_no}${apartment_no} ${city}`.trim();
}
